import { ReactNode } from 'react'
import { Box } from '@machobear/design-system'

interface Props {
  icon: ReactNode
  backgroundColor: string
}

export const IconWithBackground = ({ icon, backgroundColor }: Props) => (
  <Box
    style={{ backgroundColor, width: '28px', height: '28px' }}
    display="flex"
    alignItems="center"
    justifyContent="center"
    borderRadius="small"
    padding="xxxsmall"
  >
    {icon}
  </Box>
)
